var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex container"},[_c('ProductsMenu',{staticClass:"text-left px-2 pt-2",attrs:{"selected":_vm.selected},on:{"close":function($event){_vm.showMenu = false}}}),_c('div',{staticClass:"flex-grow-1 pt-3"},[_c('RouterView',{on:{"selected":function($event){_vm.selected = $event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }